export default __webpack_public_path__ + "static/media/ManuMalvezzi.ef38f33a.jpg";